module.exports = "/* You can add global styles to this file, and also import other style files */\n.navbar-text {\n    font-size: 2rem;\n}\n.small, small {\n    font-size: 60%;\n}\n.form-text {\n    font-size: .90rem;\n}\n.obligatorio{\n    color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles